import { ElementNode } from 'lexical';

export class LayoutItemNode extends ElementNode {
  static getType() {
    return 'layout-item';
  }

  static clone(node) {
    return new LayoutItemNode(node.__key);
  }

  createDOM(config) {
    const dom = document.createElement('div');
    if (config.theme.layoutItem) {
      dom.className = config.theme.layoutItem;
    }
    return dom;
  }

  updateDOM() {
    return false;
  }

  static importDOM() {
    return {
      div: (domNode) => {
        if (!domNode.classList.contains('PlaygroundEditorTheme__layoutItem')) {
          return null;
        }
        return {
          conversion: () => ({ node: $createLayoutItemNode() }),
          priority: 2,
        };
      },
    };
  }

  static importJSON() {
    return $createLayoutItemNode();
  }

  isShadowRoot() {
    return true;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'layout-item',
      version: 1,
    };
  }
}

export function $createLayoutItemNode() {
  return new LayoutItemNode();
}

export function $isLayoutItemNode(node) {
  return node instanceof LayoutItemNode;
}
